export const initialState = {
  scrollPosition: 0,
  blogPaginationSettings: {
    currentPage: 1,
    pagesAmount: 19
  },
  blogCards: [
    {
      id: '32432',
      title: 'Lorem ipsum dolor',
      imageUrl: '',
      date: new Date().setHours(11),
      popular: false,
      category: 'tycoon news'
    },
    {
      id: '3453cer',
      title: 'Lorem ipsum dolor',
      imageUrl: '',
      date: new Date('04-28-2021').getTime(),
      popular: false,
      category: 'tycoon news'
    },
    {
      id: '12321ds',
      title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      imageUrl: '',
      date: new Date(0).getTime(),
      popular: false,
      category: 'tycoon news'
    }
  ],
  postMock: {
    title: 'Lorem ipsum dolor',
    imageUrl: '',
    date: new Date('04-28-2021').getTime(),
    category: 'Tycoon News',
    author: 'Igor Shyrochyn',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Elementum sagittis vitae et leo duis ut diam quam nulla. Mi eget mauris pharetra et ultrices neque ornare aenean euismod. Sagittis aliquam malesuada bibendum arcu vitae elementum curabitur. Ut aliquam purus sit amet. Placerat duis ultricies lacus sed turpis tincidunt id aliquet risus. Diam maecenas sed enim ut sem viverra aliquet eget sit. Euismod elementum nisi quis eleifend quam adipiscing. Mauris in aliquam sem fringilla ut morbi tincidunt augue. Tincidunt praesent semper feugiat nibh sed pulvinar. Dictumst vestibulum rhoncus est pellentesque elit ullamcorper dignissim cras. Aliquam etiam erat velit scelerisque. Quam viverra orci sagittis eu volutpat odio facilisis. Diam maecenas ultricies mi eget mauris pharetra et. Maecenas sed enim ut sem viverra aliquet eget. Non consectetur a erat nam at lectus urna duis. Purus sit amet volutpat consequat mauris nunc. Amet volutpat consequat mauris nunc congue nisi. Arcu odio ut sem nulla pharetra diam sit. Est lorem ipsum dolor sit amet consectetur. Tincidunt augue interdum velit euismod. Quam adipiscing vitae proin sagittis nisl rhoncus mattis rhoncus. Laoreet sit amet cursus sit amet dictum sit. Vehicula ipsum a arcu cursus vitae. Dolor sit amet consectetur adipiscing elit duis. Dictum non consectetur a erat nam at. Et netus et malesuada fames ac turpis egestas maecenas pharetra. Sed cras ornare arcu dui vivamus. Leo duis ut diam quam nulla porttitor massa id. A diam maecenas sed enim ut sem viverra. Justo eget magna fermentum iaculis. Aliquet eget sit amet tellus. Id cursus metus aliquam eleifend. Lectus proin nibh nisl condimentum id venenatis. Cras ornare arcu dui vivamus arcu felis bibendum. Risus in hendrerit gravida rutrum quisque non tellus. Cursus turpis massa tincidunt dui ut ornare lectus sit amet. Nulla facilisi etiam dignissim diam quis enim. Interdum consectetur libero id faucibus nisl. Blandit massa enim nec dui nunc mattis. Eu volutpat odio facilisis mauris. Eget arcu dictum varius duis at consectetur. Velit scelerisque in dictum non. Ac auctor augue mauris augue neque gravida in fermentum et. Congue nisi vitae suscipit tellus. Blandit cursus risus at ultrices.'
  }
}